// Content for the multi-page SoftPro site, adapted from the reference site.
export const SERVICE_PAGES = {
  gevelreiniging: {
    slug: "gevelreiniging",
    label: "Gevelreiniging",
    heroTitle: "Gevelreiniging met Softwash",
    heroSubtitle:
      "Laat jouw gevel weer stralen met de Softwash-methode: veilig, grondig en duurzaam. Geen schade door hoge druk, maar een blijvend schoon resultaat.",
    heroImage:
      "https://images.pexels.com/photos/18078684/pexels-photo-18078684.jpeg?auto=compress&cs=tinysrgb&w=1920",
    lead: {
      title: "Gevel laten reinigen met Softwash",
      paragraphs: [
        "Gevelreiniging met Softwash is een veilige en effectieve manier om hardnekkige vervuiling zoals algen, mossen, schimmels en atmosferisch vuil te verwijderen — zónder de gevel te beschadigen. In plaats van agressieve hogedruk gebruiken we lage druk in combinatie met een biologisch afbreekbaar reinigingsmiddel dat diep in het oppervlak doordringt.",
        "De Softwash-methode pakt niet alleen het zichtbare vuil aan, maar vernietigt ook de micro-organismen en hun wortels, waardoor de gevel veel langer schoon blijft. Deze techniek is geschikt voor alle soorten gevels — van baksteen tot stucwerk en damwanden — en voorkomt schade zoals loslatende voegen of poreusheid van het materiaal.",
      ],
    },
    benefitsTitle: "Waarom kiezen voor gevelreiniging door een specialist?",
    benefits: [
      "Gevelreiniging met lage druk",
      "Veilige reinigingsmethode",
      "Gevelreiniging zonder schades",
      "Direct en blijvend resultaat",
      "Langdurig resultaat",
      "Gratis proefstuk",
      "Geen hoogwerkers nodig",
    ],
    process: {
      title: "Werkwijze van Softwash gevelreiniging",
      paragraphs: [
        "Bij gevelreiniging met Softwash werken we met lage druk in combinatie met een biologisch afbreekbaar reinigingsmiddel. Eerst bevochtigen we de gevel om het oppervlak voor te bereiden, waarna het reinigingsmiddel zorgvuldig wordt aangebracht.",
        "Dit middel dringt diep door in de poriën en breekt organische vervuiling zoals algen, schimmels, mossen en bacteriën volledig af — tot in de wortels. Waar hogedruk vaak alleen oppervlakkig reinigt, zorgt Softwash voor een langdurig schoon resultaat zonder schade en vertraagt het hergroei.",
        "Na de inwerktijd spoelen we de gevel na met lage druk. Dit gebeurt gecontroleerd en zonder risico op beschadiging. Het resultaat: een gevel die grondig schoon is én zijn oorspronkelijke uitstraling terugkrijgt.",
      ],
    },
    before:
      "https://images.pexels.com/photos/34756467/pexels-photo-34756467.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after:
      "https://images.pexels.com/photos/18078684/pexels-photo-18078684.jpeg?auto=compress&cs=tinysrgb&w=1200",
    sections: [
      {
        heading: "Waarom je gevel laten reinigen belangrijk is",
        body: "Je gevel wordt dagelijks blootgesteld aan regen, wind, algen, mos en luchtvervuiling. Dit kan leiden tot verkleuring, schade en zelfs vochtproblemen. Door je gevel regelmatig te laten reinigen voorkom je deze problemen, behoudt je pand zijn waarde en verleng je de levensduur van de gevelmaterialen.",
      },
      {
        heading: "Onze aanpak voor gevelreiniging met Softwash",
        body: "We gebruiken geen schadelijke hogedruk, maar een zachte, effectieve techniek met milieuvriendelijke reinigingsmiddelen. Onze aanpak omvat:",
        list: [
          "Bepaling van de mate van vervuiling",
          "Voorbereiding van de werkomgeving",
          "Verwijderen van losse vervuiling",
          "Aanbrengen van het Softwash-reinigingsmiddel",
        ],
      },
      {
        heading: "Wanneer is het tijd om je gevel te reinigen?",
        body: "Herken je een of meer van deze signalen? Dan is het tijd om in actie te komen:",
        list: [
          "Zwarte aanslag door roet",
          "Groene aanslag door algen of mos",
          "Verkleuring van de gevel door vuil",
          "Vochtplekken of schimmelvorming",
        ],
      },
      {
        heading: "Impregneren na gevelreiniging",
        body: "Wil je jouw gevel niet alleen schoon, maar ook langdurig beschermd houden? Na de reiniging is impregneren de ideale vervolgstap. Je creëert een water- en vuilafstotende laag die voorkomt dat vuil en vocht opnieuw grip krijgen op het oppervlak.",
      },
    ],
    metaTitle: "Professionele Gevelreiniging met Softwash | SoftPro",
    metaDesc:
      "Uw gevel laten reinigen? Kies voor gevelreiniging met SoftPro. Softwash voorkomt schade en pakt vuil bij de kern aan.",
  },

  dakreiniging: {
    slug: "dakreiniging",
    label: "Dakreiniging",
    heroTitle: "Dakreiniging met Softwash",
    heroSubtitle:
      "Dakreiniging met Softwash: veilig, grondig en duurzaam. Vraag vandaag nog een offerte aan en ontdek wat wij voor jouw dak kunnen betekenen.",
    heroImage:
      "https://images.pexels.com/photos/35153375/pexels-photo-35153375.jpeg?auto=compress&cs=tinysrgb&w=1920",
    lead: {
      title: "Dakpannen reinigen met Softwash",
      paragraphs: [
        "Softwash dakreiniging is de veilige manier om jouw dakpannen grondig te reinigen zonder schade aan te brengen. In plaats van agressieve hogedruk gebruiken we een biologisch afbreekbaar reinigingsmiddel dat met lage druk wordt aangebracht en diep doordringt in de poriën van de dakpannen.",
        "Dit middel verwijdert niet alleen zichtbare mossen, algen en schimmels, maar vernietigt ook de onderliggende wortels. Hierdoor blijft het dak langer schoon en wordt hergroei sterk vertraagd. Dankzij de lage druk raken de dakpannen niet los of beschadigd, zoals vaak wel gebeurt bij traditionele hogedrukreiniging.",
      ],
    },
    benefitsTitle: "Waarom kiezen voor dakreiniging door een specialist?",
    benefits: [
      "Dakreiniging met lage druk",
      "Veilige reinigingsmethode",
      "Dakreiniging zonder schades",
      "Direct en blijvend resultaat",
      "Langdurig resultaat",
      "Gratis proefstuk",
      "Geen hoogwerkers nodig",
    ],
    process: {
      title: "Zo werkt Softwash dakreiniging",
      paragraphs: [
        "We beginnen altijd met een visuele inspectie van het dak. We controleren op beschadigde pannen, loszittende elementen en de mate van vervuiling. Vervolgens maken we het dak nat en brengen we met lage druk ons biologisch afbreekbare reinigingsmiddel aan.",
        "Het middel dringt diep door in de dakpannen en pakt mos, algen, schimmels en bacteriën aan bij de bron. In tegenstelling tot hogedruk worden ook de wortelstructuren vernietigd, waardoor hergroei sterk wordt vertraagd en het dak langdurig beschermd blijft.",
        "Na de inwerktijd spoelen we het dak lichtjes na óf laten we de regen het werk doen. Doordat er geen hoge druk aan te pas komt, blijven de dakpannen volledig intact en voorkom je schade aan de dakconstructie.",
      ],
    },
    before:
      "https://images.pexels.com/photos/34190870/pexels-photo-34190870.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after:
      "https://images.pexels.com/photos/35153375/pexels-photo-35153375.jpeg?auto=compress&cs=tinysrgb&w=1200",
    sections: [
      {
        heading: "Waarom je dak laten reinigen belangrijk is",
        body: "Daken krijgen veel te verduren door regen, wind en zon. Hierdoor ontstaan mos, algen en andere vervuiling die niet alleen het uiterlijk beïnvloeden, maar ook de dakpannen aantasten. Regelmatige reiniging voorkomt schade, verlengt de levensduur van je dak en behoudt de waarde van je woning of pand.",
      },
      {
        heading: "Onze aanpak voor het reinigen van dakpannen",
        body: "Bij SoftPro kiezen we voor een zachte, maar uiterst effectieve aanpak. Ons proces omvat:",
        list: [
          "Het verwijderen van mos, algen en schimmels van dakpannen",
          "Een preventieve behandeling tegen nieuwe vervuiling",
          "Het gebruik van milieuvriendelijke en veilige reinigingsmiddelen",
        ],
      },
      {
        heading: "Duurzaam resultaat voor je dak",
        body: "Na onze behandeling blijft je dak langer schoon. Softwash creëert een beschermende werking op de dakpannen, waardoor toekomstige vervuiling minder snel grip krijgt. Je dak ziet er niet alleen stralend uit, maar blijft ook langer schoon zonder frequente onderhoudsbeurten.",
      },
    ],
    metaTitle: "Dakreiniging met Softwash | Milieuvriendelijk & Langdurig Schoon",
    metaDesc:
      "Laat je dak stralen met dakreiniging via de Softwash-methode. Veilig voor je dakpannen en duurzaam resultaat. Vraag nu een offerte aan.",
  },

  "bedrijfspand-reinigen": {
    slug: "bedrijfspand-reinigen",
    label: "Bedrijfspandreiniging",
    heroTitle: "Bedrijfspand reinigen met Softwash",
    heroSubtitle:
      "Laat jouw bedrijfspand professioneel reinigen met de Softwash-methode. Ontvang vandaag nog een vrijblijvende offerte op maat.",
    heroImage:
      "https://images.pexels.com/photos/20433881/pexels-photo-20433881.jpeg?auto=compress&cs=tinysrgb&w=1920",
    lead: {
      title: "Een schoon bedrijfspand met Softwash",
      paragraphs: [
        "Een schoon bedrijfspand is hét visitekaartje van jouw organisatie. Met Softwash reinigen we gevels, daken en overige buitenoppervlakken grondig, zonder schadelijke hogedruk. Onze lage druk in combinatie met een biologisch afbreekbaar reinigingsmiddel verwijdert algen, mos, schimmel en vuil tot diep in het materiaal — zonder schade aan het pand.",
        "Softwash is uitermate geschikt voor bedrijfspanden met kwetsbare gevelmaterialen, damwanden of oudere dakbedekking. De methode is veilig, duurzaam en zorgt ervoor dat jouw pand er weer representatief uitziet. Door de diepe werking blijft het resultaat langer zichtbaar, wat onderhoudskosten verlaagt.",
      ],
    },
    benefitsTitle: "Waarom kiezen voor bedrijfspand reinigen door een specialist?",
    benefits: [
      "Bedrijfspand reinigen met lage druk",
      "Veilige reinigingsmethode",
      "Reinigen zonder schades",
      "Direct en blijvend resultaat",
      "Langdurig resultaat",
      "Gratis proefstuk",
      "Geen hoogwerkers nodig",
    ],
    process: {
      title: "Werkwijze gevelreiniging voor bedrijfspanden",
      paragraphs: [
        "We starten elk project met een zorgvuldige inspectie van de gevel. Daarbij letten we op het type ondergrond, de mate van vervuiling en eventuele kwetsbare delen van het pand. Zo bepalen we de juiste aanpak en dosering.",
        "Na de voorbereiding maken we de gevel nat en brengen we het Softwash-reinigingsmiddel aan met lage druk. Het dringt diep door in baksteen, stucwerk, beplating of damwand en breekt vervuiling volledig af tot in de kern. De zachte aanpak voorkomt schade aan voegen, coatinglagen en gevelbekleding.",
        "Na voldoende inwerktijd wordt het vuil afgespoeld óf door weersinvloeden langzaam weggespoeld. Het resultaat is een schone, verzorgde gevel zonder schade.",
      ],
    },
    before:
      "https://images.pexels.com/photos/20296972/pexels-photo-20296972.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after:
      "https://images.pexels.com/photos/20433881/pexels-photo-20433881.jpeg?auto=compress&cs=tinysrgb&w=1200",
    sections: [
      {
        heading: "Waarom gevelreiniging van je bedrijfspand belangrijk is",
        body: "De buitenkant van je pand is het eerste dat klanten en bezoekers zien. Een vervuilde gevel kan een negatieve indruk achterlaten en afbreuk doen aan de uitstraling van je bedrijf. Daarnaast kan vuilophoping zoals algen, mos, roet en stof op lange termijn schade veroorzaken aan de gevelmaterialen.",
      },
      {
        heading: "Voordelen van bedrijfspand-reiniging door SoftPro",
        list: [
          "Veilige en zachte reinigingstechniek met lage druk — ideaal voor kwetsbare materialen zoals natuursteen, baksteen en stucwerk.",
          "Langdurig schone gevels doordat vuil bij de bron wordt aangepakt.",
          "Milieuvriendelijk en veilig voor de omgeving dankzij biologisch afbreekbare middelen.",
          "Verhoogde waarde en professionele uitstraling van je bedrijf.",
          "Geschikt voor alle soorten bedrijfspanden: kantoren, magazijnen, winkels en industriële panden.",
        ],
      },
      {
        heading: "Waarom kiezen voor SoftPro voor je bedrijfspand?",
        list: [
          "Expertise in het reinigen van grote bedrijfsgebouwen en complexe gevels",
          "2 jaar garantie op onze gevelreinigingswerkzaamheden",
          "Flexibele planning die zich aanpast aan jouw bedrijfsuren",
          "Milieuvriendelijk en conform alle milieunormen",
        ],
      },
    ],
    metaTitle: "Bedrijfspand reinigen met Softwash | SoftPro",
    metaDesc:
      "Bedrijfspand laten reinigen? Kies voor bedrijfspand reinigen met Softwash. Voorkomt schade en pakt vuil bij de kern aan.",
  },

  "terras-reinigen": {
    slug: "terras-reinigen",
    label: "Terras- en opritreiniging",
    heroTitle: "Terras & Vlonders reinigen met Softwash",
    heroSubtitle:
      "Van keramische tegels tot composiet vlonders: wij pakken groene aanslag en vuil grondig aan voor een frisse buitenruimte — zonder schade.",
    heroImage:
      "https://images.pexels.com/photos/29952419/pexels-photo-29952419.jpeg?auto=compress&cs=tinysrgb&w=1920",
    lead: {
      title: "Terras laten reinigen met Softwash",
      paragraphs: [
        "Je terras of vlonder heeft flink te lijden onder weer en wind. Groene aanslag, algen en vuil maken je buitenruimte niet alleen minder mooi, maar ook glad en onveilig. Met de Softwash-methode reinigen we jouw terras zacht en grondig, zonder de ondergrond te beschadigen.",
        "Door de lage druk en het biologisch afbreekbare reinigingsmiddel pakken we vervuiling bij de kern aan. Het resultaat: een frisse, veilige buitenruimte die veel langer schoon blijft dan bij traditionele hogedrukreiniging.",
      ],
    },
    benefitsTitle: "Waarom kiezen voor terrasreiniging door een specialist?",
    benefits: [
      "Terrasreiniging met lage druk",
      "Veilige reinigingsmethode",
      "Reinigen zonder schade aan voegen",
      "Direct en blijvend resultaat",
      "Minder gladheid en aanslag",
      "Gratis proefstuk",
      "Milieuvriendelijk",
    ],
    process: {
      title: "Zo reinigen wij jouw terras",
      paragraphs: [
        "We beoordelen eerst de ondergrond en de mate van vervuiling. Vervolgens bevochtigen we het terras en brengen we het Softwash-middel aan dat algen, mos en vuil tot in de kern afbreekt.",
        "Na de inwerktijd spoelen we het terras rustig na met lage druk. Zo blijven voegen en tegels intact en voorkomen we dat de ondergrond poreus wordt.",
      ],
    },
    before:
      "https://images.pexels.com/photos/34190870/pexels-photo-34190870.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after:
      "https://images.pexels.com/photos/29952419/pexels-photo-29952419.jpeg?auto=compress&cs=tinysrgb&w=1200",
    sections: [
      {
        heading: "Welke ondergronden reinigen wij?",
        body: "Dankzij de veelzijdigheid van Softwash reinigen we vrijwel elk type terras en vlonder:",
        list: [
          "Keramische tegels",
          "Natuursteen",
          "Betonsteen",
          "Houten vlonders",
          "Composiet",
          "Kunststof terrassen",
        ],
      },
      {
        heading: "Langer schoon en veiliger",
        body: "Doordat we de vervuiling bij de bron aanpakken, komt aanslag minder snel terug. Je terras blijft langer schoon, ziet er verzorgd uit en wordt bovendien minder glad — veiliger voor het hele gezin.",
      },
    ],
    metaTitle: "Terras & Vlonders reinigen met Softwash | SoftPro",
    metaDesc:
      "Terras of vlonder laten reinigen? Met de Softwash-methode verwijderen wij groene aanslag en vuil veilig en duurzaam.",
  },

  dakcoating: {
    slug: "dakcoating",
    label: "Dakcoating",
    heroTitle: "Dakcoating voor een beschermd en fris dak",
    heroSubtitle:
      "Geef je dak na een grondige reiniging een beschermende, waterafstotende coating. Een frisse kleur, langere levensduur en minder aangroei van mos en algen.",
    heroImage:
      "https://images.unsplash.com/photo-1726589004565-bedfba94d3a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    lead: {
      title: "Dakcoating: bescherming én uitstraling",
      paragraphs: [
        "Dakcoating is de ideale vervolgstap na een professionele dakreiniging. We brengen een hoogwaardige, waterafstotende coating aan die diep in de dakpannen trekt en het oppervlak beschermt tegen weersinvloeden, vuil en hernieuwde aangroei van mos en algen.",
        "Naast de beschermende werking krijgt je dak een egale, frisse kleur terug. Zo verlengt een dakcoating niet alleen de levensduur van je dak, maar geeft het je woning ook meteen een verzorgde uitstraling — een investering die zichzelf terugverdient.",
      ],
    },
    benefitsTitle: "Waarom kiezen voor een dakcoating door een specialist?",
    benefits: [
      "Waterafstotende bescherming",
      "Langere levensduur van het dak",
      "Frisse, egale kleur",
      "Minder aangroei van mos en algen",
      "Aangebracht na grondige reiniging",
      "Gratis proefstuk",
      "Vakkundige uitvoering",
    ],
    process: {
      title: "Zo brengen wij een dakcoating aan",
      paragraphs: [
        "Een goede coating begint met een schone ondergrond. We reinigen daarom eerst het volledige dak met de Softwash-methode, zodat mos, algen en vuil volledig verdwenen zijn en de coating optimaal kan hechten.",
        "Vervolgens controleren we het dak op beschadigde of poreuze pannen. Waar nodig herstellen we deze voordat we beginnen. Daarna brengen we de coating gelijkmatig aan in meerdere lagen, afgestemd op het type dakpan.",
        "Na het drogen ontstaat een beschermende, waterafstotende laag die vuil en vocht buiten houdt. Het resultaat is een dak dat er weer strak uitziet én langdurig beschermd is.",
      ],
    },
    before:
      "https://images.pexels.com/photos/34190870/pexels-photo-34190870.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after:
      "https://images.unsplash.com/photo-1605450099279-533bd3ce379a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    sections: [
      {
        heading: "Wanneer is dakcoating interessant?",
        body: "Een dakcoating is vooral zinvol bij daken die verweerd of verkleurd zijn, maar constructief nog in goede staat. Herken je een van deze situaties?",
        list: [
          "Een dof of verkleurd dak na jaren blootstelling",
          "Terugkerende aangroei van mos en algen",
          "Poreuze dakpannen die vocht opnemen",
          "De wens om de levensduur van het dak te verlengen",
        ],
      },
      {
        heading: "De voordelen van dakcoating op een rij",
        list: [
          "Waterafstotende laag die vocht en vuil weert",
          "Beschermt de dakpannen tegen weersinvloeden",
          "Vertraagt de terugkeer van mos en algen",
          "Geeft het dak een frisse, egale uitstraling",
        ],
      },
      {
        heading: "Altijd eerst reinigen",
        body: "Een coating aanbrengen op een vervuild dak heeft geen zin — de laag hecht dan niet goed en het resultaat is van korte duur. Daarom reinigen we het dak altijd eerst grondig met Softwash, zodat je coating optimaal presteert en jarenlang meegaat.",
      },
    ],
    metaTitle: "Dakcoating met bescherming & frisse kleur | SoftPro",
    metaDesc:
      "Dakcoating laten aanbrengen? SoftPro reinigt je dak eerst grondig en voorziet het van een waterafstotende coating voor een langere levensduur.",
  },

  "dak-en-gevelimpregnering": {
    slug: "dak-en-gevelimpregnering",
    label: "Dak- en gevelimpregnering",
    heroTitle: "Dak- en gevelimpregnering met Softwash",
    heroSubtitle:
      "Bescherm je dak of gevel met een onzichtbare, waterafstotende impregneerlaag. Vocht en vuil krijgen geen grip meer, waardoor je pand langer schoon en droog blijft.",
    heroImage:
      "https://images.unsplash.com/photo-1771502044392-2336308d0c54?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
    lead: {
      title: "Impregneren: langdurige bescherming zonder zichtbare laag",
      paragraphs: [
        "Impregneren is het aanbrengen van een waterafstotend middel dat diep in de poriën van baksteen, voegwerk of dakpannen dringt. In tegenstelling tot een coating blijft het materiaal ademen — het vocht kan naar buiten, maar regen en vuil krijgen geen grip meer.",
        "Het resultaat is een gevel of dak dat aanzienlijk minder vocht opneemt. Dit voorkomt vochtproblemen, vertraagt de aangroei van mos en algen en houdt je pand langer schoon en droog. Impregneren is de ideale afronding na een grondige reiniging.",
      ],
    },
    benefitsTitle: "Waarom kiezen voor impregneren door een specialist?",
    benefits: [
      "Waterafstotende bescherming",
      "Onzichtbaar — materiaal blijft ademen",
      "Voorkomt vochtproblemen",
      "Langer schoon en droog",
      "Vertraagt aangroei van mos en algen",
      "Tot 4 jaar garantie",
      "Gratis proefstuk",
    ],
    process: {
      title: "Zo werkt impregneren bij SoftPro",
      paragraphs: [
        "Ook impregneren begint met een schone ondergrond. We reinigen eerst het dak of de gevel met de Softwash-methode, zodat het impregneermiddel diep en gelijkmatig kan intrekken.",
        "Na het drogen brengen we het waterafstotende middel zorgvuldig aan. Het dringt door in de poriën van het materiaal en vormt een onzichtbare barrière tegen vocht en vuil, zonder het uiterlijk of de kleur te veranderen.",
        "Het materiaal blijft dampdoorlatend, waardoor opgesloten vocht kan ontsnappen. Zo voorkom je vochtschade én blijft je pand langdurig beschermd en verzorgd.",
      ],
    },
    before:
      "https://images.pexels.com/photos/34756467/pexels-photo-34756467.jpeg?auto=compress&cs=tinysrgb&w=1200",
    after:
      "https://images.unsplash.com/photo-1522623925630-28071b794383?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    sections: [
      {
        heading: "Wat levert impregneren op?",
        body: "Een impregneerbehandeling biedt duurzame bescherming voor gevels en daken. De belangrijkste voordelen:",
        list: [
          "Sterk verminderde vochtopname van het materiaal",
          "Minder kans op vochtplekken en schimmelvorming",
          "Vuil en algen hechten zich moeilijker",
          "Behoud van de oorspronkelijke uitstraling",
        ],
      },
      {
        heading: "Coating of impregneren — wat is het verschil?",
        body: "Een coating legt een zichtbare beschermlaag óp het materiaal, terwijl impregneren juist ín het materiaal trekt en onzichtbaar blijft. Impregneren houdt het oppervlak dampdoorlatend, wat het ideaal maakt voor bakstenen gevels en de meeste dakpannen. We adviseren je graag welke oplossing bij jouw situatie past.",
      },
      {
        heading: "Langdurige garantie",
        body: "Kies je na de reiniging ook voor impregneren, dan verlengen wij onze garantie naar 4 jaar. Zo weet je zeker dat je dak of gevel langdurig beschermd blijft tegen vocht en vervuiling.",
      },
    ],
    metaTitle: "Dak- en gevelimpregnering | Waterafstotend & Duurzaam | SoftPro",
    metaDesc:
      "Dak of gevel laten impregneren? SoftPro brengt een onzichtbare, waterafstotende laag aan die vocht en vuil weert. Tot 4 jaar garantie.",
  },
};

export const METHODE_PAGE = {
  heroTitle: "De Softwash Methode",
  heroSubtitle:
    "Effectief, milieuvriendelijk en veilig reinigen. Dé oplossing voor daken, gevels en meer — met een duurzaam resultaat zonder schade.",
  heroImage:
    "https://images.pexels.com/photos/1535086/pexels-photo-1535086.jpeg?auto=compress&cs=tinysrgb&w=1920",
  intro: {
    title: "Softwash uitgelegd: veilig, effectief en duurzaam",
    paragraphs: [
      "De Softwash methode is een geavanceerde reinigingstechniek die werkt met lage druk in combinatie met een biologisch afbreekbaar reinigingsmiddel. In tegenstelling tot traditionele hogedrukreiniging wordt het oppervlak niet beschadigd, maar juist op een veilige en diepwerkende manier gereinigd.",
      "Het reinigingsmiddel doodt schimmels, algen, mossen en bacteriën tot in de kern en voorkomt dat ze snel terugkomen. Softwash reinigt niet alleen het zichtbare vuil, maar pakt ook de oorzaak aan. Hierdoor blijft het oppervlak langdurig schoon en wordt veroudering of aantasting van het materiaal voorkomen.",
    ],
  },
  how: {
    title: "Hoe werkt de Softwash methode?",
    paragraphs: [
      "Softwash werkt op basis van lage druk in combinatie met een speciaal ontwikkeld, biologisch afbreekbaar reinigingsmiddel dat organische vervuiling grondig aanpakt — denk aan mossen, algen, schimmels en bacteriën.",
      "In tegenstelling tot hogedruk, die vaak alleen het zichtbare vuil verwijdert, dringt Softwash door tot in de kern van de vervuiling. Het middel breekt de vervuiling op microscopisch niveau af, waarna het vuil langzaam loskomt. Na de inwerktijd wordt het geheel nagespoeld met water.",
      "Dankzij de lage druk blijft het materiaal onbeschadigd en wordt de kans op slijtage of poreusheid tot een minimum beperkt. Het resultaat is een langdurig schoon oppervlak én duurzaam behoud van het materiaal.",
    ],
  },
  benefits: [
    { title: "Geen schade", text: "Lage druk voorkomt schade aan kwetsbare oppervlakken zoals dakpannen, gevels en hout." },
    { title: "Diepgaande reiniging", text: "Doodt micro-organismen bij de bron en voorkomt snelle hergroei van mos en algen." },
    { title: "Milieuvriendelijk", text: "De gebruikte producten zijn biologisch afbreekbaar en veilig voor planten en dieren." },
    { title: "Langdurig resultaat", text: "Je oppervlak blijft langer schoon en vereist minder onderhoud." },
    { title: "Veelzijdig", text: "Geschikt voor daken, gevels, terrassen, damwanden en meer." },
    { title: "Gratis proefstuk", text: "Je weet vooraf precies wat je kunt verwachten, geheel vrijblijvend." },
  ],
  surfaces: {
    title: "Wat kunnen wij reinigen met Softwash?",
    groups: [
      {
        name: "Gevel laten reinigen",
        items: ["Bakstenen gevel", "Stucgevel", "Geschilderde gevel", "Kunststof gevel", "Damwanden & Beplating", "Houten gevel"],
      },
      {
        name: "Dakpannen laten reinigen",
        items: ["Betonpannen", "Keramische pannen", "Vlakke pannen", "Geglazuurde pannen", "Leien pannen", "Sneldekpannen"],
      },
      {
        name: "Terrassen & Vlonders",
        items: ["Keramische tegels", "Natuursteen", "Betonsteen", "Vlonders", "Composiet", "Kunststof terrassen"],
      },
    ],
  },
  metaTitle: "Softwash Methode | Effectief, Milieuvriendelijk & Veilig Reinigen",
  metaDesc:
    "De Softwash Methode is dé veilige oplossing voor het reinigen van daken, gevels en meer. Duurzaam resultaat zonder schade.",
};
